import {
    FilterAccordionItem,
    FilterCheckbox,
    FilterChipItemButton,
} from 'components/FilterAccordion';
import { BiGridAlt } from 'react-icons/bi';
import ClusterIcon from 'components/ClusterIcon';
import ClusterTooltip from 'components/ClusterTooltip';
import ExtLink from 'components/ExtLink';
import { clusterFilterOptions } from 'utils/filters';
import styled from 'styled-components';

export function ClusterFilterOption({ children, value, ...props }) {
    return (
        <ClusterTooltip cluster={value}>
            <FilterCheckbox {...props}>
                <ClusterIcon
                    css={`
                        font-size: ${({ theme }) => theme.space_8}px;
                        margin-right: ${({ theme }) => theme.space_5}px;
                    `}
                    cluster={value}
                />
                {children}
            </FilterCheckbox>
        </ClusterTooltip>
    );
}

function ClusterFilterChipItemButton({ children, value, ...props }) {
    return (
        <ClusterTooltip cluster={value}>
            <FilterChipItemButton {...props}>
                <ClusterIcon
                    cluster={value}
                    light={true}
                    css={`
                        margin-right: ${({ theme }) => theme.space_3}px;
                    `}
                />
                {children}
            </FilterChipItemButton>
        </ClusterTooltip>
    );
}

export const ClusterHelpLink = styled(ExtLink)`
    display: block;
    text-align: center;
    font-weight: ${({ theme }) => theme.fontBold};
    font-size: ${({ theme }) => theme.space_7}px;
    line-height: 1.21em;
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.purple_1};
    text-decoration: none;
    margin-bottom: ${({ theme }) => theme.space_7}px;

    &:hover,
    &:active {
        text-decoration: underline;
        color: ${({ theme }) => theme.purple_2};
    }
`;

function ClusterFilterAccordionItem({
    label = 'Clusters',
    options = clusterFilterOptions,
    mixpanelContext = 'ClusterFilterSelect',
    Icon = BiGridAlt,
    FilterOption = ClusterFilterOption,
    FilterChipItemButton = ClusterFilterChipItemButton,
    ...props
}) {
    return (
        <FilterAccordionItem
            label={label}
            options={options}
            mixpanelContext={mixpanelContext}
            Icon={Icon}
            FilterOption={FilterOption}
            FilterChipItemButton={FilterChipItemButton}
            {...props}
        />
    );
}

export default ClusterFilterAccordionItem;
